function getOneOfEntityAnnotations(entity, targetAnnotations) {
  if (entity.metadata.annotations) {
    const annotations = Object.keys(entity.metadata.annotations);
    const intersection = annotations.filter(
      (value) => targetAnnotations.includes(value)
    );
    if (intersection.length === 1) {
      const match = intersection[0];
      return {
        name: match,
        value: entity.metadata.annotations[match]
      };
    }
    return void 0;
  }
  return void 0;
}

export { getOneOfEntityAnnotations };
//# sourceMappingURL=getOneOfEntityAnnotations.esm.js.map
